import { TPageConfig } from 'models/common.model'
import { PageIdWoofzPawNup } from './pages-map'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_PAW_NUP: Record<
  PageIdWoofzPawNup,
  TPageConfig
> = {
  [PageIdWoofzPawNup.WELCOME_PAW_NUP]: {
    id: PageIdWoofzPawNup.WELCOME_PAW_NUP,
    hasHeader: true,
  },
  [PageIdWoofzPawNup.HOW_IT_WORKS_PAW_NUP]: {
    id: PageIdWoofzPawNup.HOW_IT_WORKS_PAW_NUP,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPawNup.INTRODUCTION_PAW_NUP]: {
    id: PageIdWoofzPawNup.INTRODUCTION_PAW_NUP,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPawNup.MORNING_WALK_PAW_NUP]: {
    id: PageIdWoofzPawNup.MORNING_WALK_PAW_NUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPawNup.EVENING_WALK_PAW_NUP]: {
    id: PageIdWoofzPawNup.EVENING_WALK_PAW_NUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPawNup.FEEDING_PAW_NUP]: {
    id: PageIdWoofzPawNup.FEEDING_PAW_NUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPawNup.VET_CARE_PAW_NUP]: {
    id: PageIdWoofzPawNup.VET_CARE_PAW_NUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPawNup.TRAINING_PAW_NUP]: {
    id: PageIdWoofzPawNup.TRAINING_PAW_NUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPawNup.DISCIPLINE_PAW_NUP]: {
    id: PageIdWoofzPawNup.DISCIPLINE_PAW_NUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPawNup.CLEANUP_PAW_NUP]: {
    id: PageIdWoofzPawNup.CLEANUP_PAW_NUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPawNup.TREATS_PAW_NUP]: {
    id: PageIdWoofzPawNup.TREATS_PAW_NUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPawNup.KISSES_PAW_NUP]: {
    id: PageIdWoofzPawNup.KISSES_PAW_NUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPawNup.GROOMING_PAW_NUP]: {
    id: PageIdWoofzPawNup.GROOMING_PAW_NUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPawNup.NIGHT_DUTY_PAW_NUP]: {
    id: PageIdWoofzPawNup.NIGHT_DUTY_PAW_NUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPawNup.RULES_PAW_NUP]: {
    id: PageIdWoofzPawNup.RULES_PAW_NUP,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPawNup.ALLOWED_ON_BED_PAW_NUP]: {
    id: PageIdWoofzPawNup.ALLOWED_ON_BED_PAW_NUP,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPawNup.TABLE_SCRAPS_PAW_NUP]: {
    id: PageIdWoofzPawNup.TABLE_SCRAPS_PAW_NUP,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPawNup.WHINES_PAW_NUP]: {
    id: PageIdWoofzPawNup.WHINES_PAW_NUP,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPawNup.COMMANDS_PAW_NUP]: {
    id: PageIdWoofzPawNup.COMMANDS_PAW_NUP,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPawNup.LISTEN_TO_PAW_NUP]: {
    id: PageIdWoofzPawNup.LISTEN_TO_PAW_NUP,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPawNup.CREATING_AGREEMENT_PAW_NUP]: {
    id: PageIdWoofzPawNup.CREATING_AGREEMENT_PAW_NUP,
  },
  [PageIdWoofzPawNup.CONFLICT_PROOF_PAW_NUP]: {
    id: PageIdWoofzPawNup.CONFLICT_PROOF_PAW_NUP,
    hasHeader: true,
  },
  [PageIdWoofzPawNup.EMAIL_PAW_NUP]: {
    id: PageIdWoofzPawNup.EMAIL_PAW_NUP,
    hasHeader: true,
  },
  [PageIdWoofzPawNup.AGREEMENT_PAW_NUP]: {
    id: PageIdWoofzPawNup.AGREEMENT_PAW_NUP,
    hasHeader: true,
  },
  [PageIdWoofzPawNup.DOWNLOAD_PAW_NUP]: {
    id: PageIdWoofzPawNup.DOWNLOAD_PAW_NUP,
    hasHeader: true,
  },
}
